import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isConfirmationGoodieUnusedBudgetPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { onConfirmUnusedGoodieBudget } from '../../../../giveaway/redux/giveaway-landing/giveaway-landing.actions';
import { formattedSelectedGiveawayBudgetSelector, selectedGiveawayColorWithFallbackSelector } from '../../../../giveaway/redux/giveaway-landing/giveaway-landing.selectors';
import { ConfirmGoodieUnusedBudgetPopupComponent } from './confirm-goodie-unused-budget-popup';
const mapStateToProps = createStructuredSelector({
  open: isConfirmationGoodieUnusedBudgetPopupShownSelector,
  budget: formattedSelectedGiveawayBudgetSelector,
  buttonColor: selectedGiveawayColorWithFallbackSelector
});
const mapDispatchToProps = dispatch => ({
  onConfirm: () => dispatch(onConfirmUnusedGoodieBudget()),
  onClose: () => dispatch(hidePopup())
});
export const ConfirmGoodieUnusedBudgetPopup = connect(mapStateToProps, mapDispatchToProps)(ConfirmGoodieUnusedBudgetPopupComponent);